export default __webpack_public_path__ + "static/media/video-image-3.70fc919a.png";